import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTimeFormatter } from '../../../../../data/hooks/datetimeHooks';
import CollapsableArea from '../../../../elements/CollapsableArea/CollapsableArea';
import ExpandCollapseButton from '../../../../elements/ExpandCollapseButton/ExpandCollapseButton';
import ProgramItem from '../ProgramItem';
import AditionalSelectionAvailableMessage from './AditionalSelectionAvailableMessage/AditionalSelectionAvailableMessage';
import OutsideFilterMessage from './OutsideFilterMessage/OutsideFilterMessage';
import styles from './ProgramGroup.module.scss';

const SAVED_EXPANDED_STATUS = {};

function ProgramGroup(props) {
    const { event, i18n, round, items, unfilteredGroup, expanded: startExpanded, scrollIntoView } = props,
        [expanded, setExpanded] = useState(startExpanded !== undefined ? startExpanded : SAVED_EXPANDED_STATUS[round.id]),
        style = {
            backgroundColor: round.block_color || event.settings.secondary_color,
            borderColor: round.block_color || event.settings.secondary_color,
        },
        ref = useRef(),
        formatTime = useTimeFormatter();

    useEffect(() => {
        if (scrollIntoView) ref.current?.scrollIntoView({ behavior: 'smooth' });
    }, [scrollIntoView]);

    useEffect(() => {
        SAVED_EXPANDED_STATUS[round.id] = expanded;
    }, [expanded]);

    useEffect(() => {
        if (startExpanded !== undefined) setExpanded(startExpanded);
    }, [startExpanded]);

    const handleToogleExpandCollapse = useCallback(() => {
        setExpanded((expanded) => !expanded);
    }, []);

    const handleSessionSelectionChange = useCallback(() => {
        setExpanded(false);
    }, []);

    let title;
    if (round) {
        title = round.name;
    } else {
        if (!event.settings.workshops_label) {
            console.warn('Hardcoded string used!');
        }
        title = event.settings.workshops_label || 'Workshops';
    }

    let hasItemSelected = !!items.find((item) => item.is_selected),
        hasSelectableSessions = !!items.find((item) => item.is_selectable);

    return (
        <div ref={ref} className={styles.ProgramGroup} style={style}>
            <div className={styles.head} onClick={handleToogleExpandCollapse}>
                {round ? <span className={styles.roundStart}>{formatTime(round.start_local)}</span> : null}
                <span className={styles.title}>{title}</span>
                <ExpandCollapseButton expanded={expanded} />
            </div>
            <CollapsableArea expanded={!hasItemSelected && !expanded}>
                <div className={styles.selectItem} onClick={handleToogleExpandCollapse}>
                    {event.settings.workshop_selection && hasSelectableSessions ? round.round_choice_label || i18n['label.tap-to-select-workshop'] : i18n['label.session-overview']}
                </div>
            </CollapsableArea>
            {items.map((item, index) => {
                const itemExpanded = item.is_selected || item.is_favorite || expanded;
                return (
                    <CollapsableArea
                        className={[styles.itemWrapper, itemExpanded ? styles.expanded : styles.collapsed, index === items.length - 1 ? styles.lastItem : null].join(' ')}
                        expanded={itemExpanded}
                        key={item.id}>
                        <ProgramItem item={item} i18n={i18n} event={event} round={round} onSessionSelectionChange={handleSessionSelectionChange} key={item.id} />
                    </CollapsableArea>
                );
            })}
            <OutsideFilterMessage event={event} items={items} unfilteredGroup={unfilteredGroup} />
            <CollapsableArea expanded={!expanded}>
                <AditionalSelectionAvailableMessage event={event} items={items} onClick={handleToogleExpandCollapse} />
            </CollapsableArea>
        </div>
    );
}

export default ProgramGroup;
